"use client";

import { identifyUser, resetUser } from "@pex/analytics/client";
import { useAuth } from "@pex/auth/client";
import { getConsentFromCookie } from "@pex/cookie-consent/client";
import { useEffect } from "react";

export function AnalyticsIdentity() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      const stored = getConsentFromCookie();
      if (stored?.categories.analytics) {
        identifyUser(user.id);
      }
    } else {
      resetUser();
    }
  }, [user]);

  return null;
}
